"use client";

import { Modal, ModalBody, ModalContent, ModalHeader } from "@nextui-org/react";
import { create } from "zustand";
import { SeaBayIcon } from "@/03-presenters/components/ui/icons";
import { useGetSeaBayPayment } from "@/app/[locale]/tiktok/pricing/hooks";
import { LoadingOverlay } from "@mantine/core";
import Link from "next/link";
import Image from "next/image";
import { useEffect, useState } from "react";
import { cx } from "class-variance-authority";
import SeaBayPayAction from "@/app/[locale]/tiktok/pricing/SeaBayPayAction";
function CommonCard({
  count,
  price,
  isActive,
  onClick,
  originalPrice
}: {
  count: number;
  price: number;
  isActive: boolean;
  onClick: () => void;
  originalPrice: number;
}) {
  return <div className={cx("relative flex w-[19%] cursor-pointer flex-col gap-4 rounded-md border-1 border-solid border-gray-200 px-4 py-6 transition-all duration-300", isActive && "border-primary")} onClick={onClick} data-sentry-component="CommonCard" data-sentry-source-file="SeaBayPayment.tsx">
      <Image src="/pricing/seabay_bg2.webp" alt="sea-bay-bg" width={396} height={237} className="absolute left-0 top-0 w-full" data-sentry-element="Image" data-sentry-source-file="SeaBayPayment.tsx" />
      <div className="flex items-center gap-1">
        <span className="text-lg">{count}</span>
        <SeaBayIcon height={24} width={24} data-sentry-element="SeaBayIcon" data-sentry-source-file="SeaBayPayment.tsx" />
      </div>
      <div className="flex items-end gap-2">
        <span className="text-3xl font-semibold text-primary">
          ¥{price / 100}
        </span>
        {originalPrice ? <span className="pb-1 text-gray-500 line-through">
            ¥{originalPrice / 100}
          </span> : null}
      </div>
    </div>;
}
export const seaBayModalStore = create<{
  title: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean, options?: {
    title?: string;
  }) => void;
  setTitle: (title: string) => void;
}>(set => ({
  isOpen: false,
  title: "",
  setIsOpen: (isOpen: boolean, options?: {
    title?: string;
  }) => set({
    isOpen,
    title: options?.title ?? ""
  }),
  setTitle: (title: string) => set({
    title
  })
}));
export const SeaBayPayment = () => {
  const isOpen = seaBayModalStore(state => state.isOpen);
  const setIsOpen = seaBayModalStore(state => state.setIsOpen);
  const title = seaBayModalStore(state => state.title);
  const setTitle = seaBayModalStore(state => state.setTitle);
  const [selectedPackageId, setSelectedPackageId] = useState<number | null>(null);
  const {
    data,
    isLoading
  } = useGetSeaBayPayment();
  useEffect(() => {
    const firsPackage = data?.[0]?.topup_package_id;
    if (firsPackage) {
      setSelectedPackageId(firsPackage);
    }
  }, [data]);
  useEffect(() => {
    if (!isOpen) {
      setTitle("");
    }
  }, [isOpen, setTitle]);
  const selectedPackage = data?.find(item => item.topup_package_id === selectedPackageId);
  return <Modal isOpen={isOpen} onOpenChange={setIsOpen} isDismissable={false} size="5xl" data-sentry-element="Modal" data-sentry-component="SeaBayPayment" data-sentry-source-file="SeaBayPayment.tsx">
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="SeaBayPayment.tsx">
        <ModalHeader className="px-0 py-0" data-sentry-element="ModalHeader" data-sentry-source-file="SeaBayPayment.tsx">
          {title && <div className="fixed left-1/2 top-[10%] z-20 -translate-x-1/2 rounded-lg bg-white px-4 py-1 text-2xl font-medium">
              {title}
            </div>}
          <div className="flex h-[120px] w-full items-center  justify-center bg-gradient-to-r from-[#181531] via-[#2E2854] to-[#0D031C] text-3xl font-semibold text-white">
            出海贝购买
          </div>
        </ModalHeader>
        <ModalBody className="-mt-4 rounded-t-2xl bg-[#F7F7F8] p-6" data-sentry-element="ModalBody" data-sentry-source-file="SeaBayPayment.tsx">
          <div className="relative rounded-md bg-white p-4">
            <LoadingOverlay visible={isLoading} overlayProps={{
            radius: "sm",
            blur: 2
          }} loaderProps={{
            size: 22
          }} data-sentry-element="LoadingOverlay" data-sentry-source-file="SeaBayPayment.tsx" />
            <div className="flex items-center justify-between">
              {data?.map(item => <CommonCard onClick={() => setSelectedPackageId(item.topup_package_id)} key={item.topup_package_id} count={item.virtual_coin_amount} price={item.actual_amount} isActive={selectedPackageId === item.topup_package_id} originalPrice={item.original_amount} />)}
            </div>
            <div className="mt-4 flex items-center justify-between">
              <div className="flex flex-col gap-2">
                <span>订单结算</span>
                {selectedPackage?.original_amount ? <div className="flex items-center gap-2 text-xs text-[#8789A0]">
                    <span>原价：</span>
                    <span className="text-xl">
                      {selectedPackage?.original_amount / 100}
                    </span>
                  </div> : null}
                {selectedPackage?.actual_amount && <div className="flex items-center gap-2 text-xs text-[#8789A0]">
                    <span>实付金额：</span>
                    <span className="text-xl text-[#6F58F4]">
                      {selectedPackage?.actual_amount / 100}
                    </span>
                  </div>}
                {selectedPackageId && <SeaBayPayAction packageId={selectedPackageId} className="h-8 w-fit px-8 text-[14px] font-semibold" content="立即支付" />}

                <div className="flex flex-col text-xs text-[#8789A0]">
                  <div className="flex">
                    <span>付款即表同意 </span>
                    <Link className="text-primary" href="/serviceAgreement" target="_blank" data-sentry-element="Link" data-sentry-source-file="SeaBayPayment.tsx">
                      购买协议
                    </Link>
                  </div>
                  <span>
                    *付款成功后权限立即生效如需发票请前往
                    <Link href="/zh/tiktok/account" className="text-[#6F58F4]" data-sentry-element="Link" data-sentry-source-file="SeaBayPayment.tsx">
                      账户中心-开具发票
                    </Link>
                    开票
                  </span>
                </div>
              </div>
              <div className="flex flex-col items-center justify-center gap-1 pr-12">
                <Image src="/mentor_qrcode.webp" style={{
                height: 90,
                width: 90
              }} alt="qrcode" width="180" height="180" data-sentry-element="Image" data-sentry-source-file="SeaBayPayment.tsx" />
                <span className="text-sm text-[#8789A0]">出海贝购买咨询</span>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>;
};